import { createDataHook } from 'next-data-hooks';
import sdk from '../../../lib/sdk';
import { handleCategories } from '@src/pageHelpers/blog/handleCategories';

const useBlogData = createDataHook('BlogPageData', async () => {
  const [allPosts, tags, featuredPosts, mainImage] = await Promise.all([
    sdk.allPosts(),
    sdk.allTags(),
    sdk.blogFeaturedPosts(),
    sdk.mainImageUrl(),
  ]);
  const categories = await handleCategories(allPosts);

  return {
    categories,
    tags: tags.allPostTag,
    featuredPosts: featuredPosts.allMainBlogPage[0].featuredPosts,
    allPosts: allPosts.allPost,
    mainImageUrl: mainImage.allHomepage[0].desktopImage?.asset?.url ?? '',
  };
});

export default useBlogData;
